<template>
  <div class="header__dropdown-container-inner">
    <div class="header__dropdown-container-inner-featured-menu-links-container">
      <div class="header__dropdown-lists-container header__dropdown-list-menu-links-main-container">
          <ul class="header__dropdown-list header__dropdown-list-menu-links-container" v-for="(link, index) in block.link_list" :key="index">
            <li class="header__dropdown-list-links-image-container">
              <div class="mobile-header-dropdown-list-image-container" v-if="link.image">
                <img class="mobile-header-dropdown-list-image" :src="link.image" />
              </div>
              <div class="header-dropdown-list-links-container">
                <accordion-group class="header__dropdown-accordion-group" ref="header-accordion-group">
                  <accordion ref="product-details-accordion" :expand-max-height="3000" :selected="false" :auto-close="false" theme="default">
                    <a class="header__dropdown-list-title" :href="link.url" slot="heading">{{ link.title }}</a>
                    <accordion-tease :on-tease-expand="onTeaseExpand" :collapsed-height="314">
                      <ul v-for="(child_link, index) in link.children" :key="index">
                        <li class="header__dropdown-list-item">
                          <a class="header__dropdown-link" :href="child_link.url">{{ child_link.title }}</a>
                        </li>
                      </ul>
                    </accordion-tease>
                  </accordion>
                </accordion-group>
              </div>
            </li>
          </ul>
      </div>
    </div>
    <div class="header__dropdown-lists-images-container">
      <div class="header__dropdown-lists-images-inner-container">
        <a
          class="header__dropdown-image-link-container"
          v-if="block.image_1_url"
          :href="block.image_1_url"
        >
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.image_1" :alt="block.image_1_text" />
            </div>
            <div class="header-menu-image-title" v-if="block.image_1_text">
              {{ block.image_1_text }}
              <icon
                class="menu-image-link-arrow fill-white"
                name="arrow_long_right"
                size="24px"
              ></icon>
            </div>
          </div>
        </a>
        <div class="header__dropdown-image-link-container" v-else>
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.image_1" :alt="block.image_1_text" />
            </div>
            <div class="header-menu-image-title" v-if="block.image_1_text">{{ block.image_1_text }}</div>
          </div>
        </div>
        <a
          class="header__dropdown-image-link-container"
          v-if="block.image_2_url"
          :href="block.image_2_url"
        >
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.image_2" :alt="block.image_2_text" />
            </div>
            <div class="header-menu-image-title" v-if="block.image_2_text">
              {{ block.image_2_text }}
              <icon
                class="menu-image-link-arrow fill-white"
                name="arrow_long_right"
                size="24px"
              ></icon>
            </div>
          </div>
        </a>
        <div class="header__dropdown-image-link-container" v-else>
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.image_2" :alt="block.image_2_text" />
            </div>
            <div class="header-menu-image-title" v-if="block.image_2_text">{{ block.image_2_text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'
import Accordion from '@/scripts/components/basic/Accordion.vue'
import AccordionTease from '@/scripts/components/basic/AccordionTease.vue'
import Icon from '@/scripts/components/basic/Icon.vue';
import VLink from '../buttons/VLink.vue';

export default {
  name: 'NavbarMobileTextSmallImageBlocks',
  components: {
    Icon,
    VLink,
    AccordionGroup,
    Accordion,
    AccordionTease
  },
  props: {
    block: Object,
  },
  methods: {
    onTeaseExpand () {
      // tell the active accordions to update their height
      this.$refs['header-accordion-group'].accordions.filter(a => a.active)
        .forEach(a => a.setContentHeight())
    }
  }
};
</script>

<style scoped lang="scss">
.header__dropdown-container-inner {
  display: flex;
  flex-direction: column;
  padding: 15px 52px 24px 52px;
}

.header__dropdown-side-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 32px;
}

.header__dropdown-list {
  margin-top: 0;
  margin-bottom: 0;
  padding: 15px 0;

  &:first-child {
    padding-top: 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid $color-off-black;
  }

  @include desktop-up {
    margin-right: 78px;
  }
}

// .header__dropdown-featured-link {
//   font-size: 20px;
//   display: flex;
//   align-items: center;
//   margin-bottom: 24px;
//   color: $color-brand-primary;
// }

.mobile-header-menu-image-link-arrow {
  margin-left: 4px;
  color: $color-white;
}

.header__dropdown-list,
.header__dropdown-list ul {
  padding-left: 0;
  list-style: none;
}

.header__dropdown-list-title {
  display: block;
  color: $color-white;
  text-decoration: none;
  font-weight: 500;
  @include body-md;
}

.header__dropdown-link {
  display: block;
  margin-bottom: 16px;
  color: $color-white;
  @include body-sm;
  text-decoration: none;
}

.header__dropdown-container-inner-featured-menu-links-container {
  @include desktop-up {
    width: 50%;
    display: flex;
  }
}

.mobile-header-dropdown-list-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 32px;
}

.header__dropdown-list-links-image-container {
  display: flex;
  flex-direction: row;
}

.header-dropdown-list-links-container {
  width: 100%;
  ul:last-child {
    .header__dropdown-link {
      margin-bottom: 0;
    }
  }
  /deep/ .accordion__header {
    padding: 0;
  }
  /deep/ .accordion__content {
    padding-top: 16px;
  }
}

.header__dropdown-image {
  width: 100%;
  display: block;
}

.mobile-header-dropdown-list-image-container {
  display: block;

  @include desktop-up {
    display: none;
  }
}

.header__dropdown-lists-images-inner-container {
  margin-bottom: 33px;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
  position: relative;
  display: flex;
  margin: 0;
  padding-left: 0;
}

.header__dropdown-image-link-container {
  display: inline-block;
  list-style: none;
  width: 224px;
  vertical-align: top;
  margin-right: 16px;
  text-decoration: none;
}

.header__dropdown-image-link-inner-container {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: 224px;
}

.header__dropdown-image-container {
  margin-bottom: 16px;
}

.header-menu-image-title {
  display: flex;
  align-items: center;
  color: $color-white;
  font-family: $font-family-primary;
  font-size: rem(20);
  line-height: rem(24);
  letter-spacing: rem(-0.1);
}

.menu-image-link-arrow {
  margin-left: 4px;
  fill: $color-white;
  display: none;
}

.header__menu-main-inner-link {
  margin-top: 32px;
  color: $color-white;
}
</style>
